// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { API_CONSTANTS } from '@client/app/core/constants/api.constant';
import { GlobalHelperService } from '@client/app/services/global-helper/global-helper.service';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PageDetailsComponent } from '@client/app/components/pagedetails/details/page-details.component';

@Component({
    selector: 'table-page-details',
    standalone: false,
    template: `
        <div [attr.aria-label]="openPageDetailsMsg"
             *ngIf="hasAccessToDetailsOverlay"
             data-test="open-page-details-button"
             (click)="goToPageDetails()"
             tabindex="0"
             role="button"
             monEventTrigger="actionTrigger"
             [monEventParams]="{action: 'open-page-details', params: {module: moduleName}}"
             class="btn btn-secondary">
            <span
                [ngClass]="['TABLES', 'PAGEDETAILS'] | monIcons"
                aria-hidden="true">
            </span>
        </div>
    `,
})
export class TablePageDetailsComponent implements OnInit {
    @Input() page: any;
    @Input() target?: string | undefined;
    @Input() subTarget?: string | undefined;
    @Input() ref?: string | undefined;
    @Input() infoType?: any;

    @Output() callBack = new EventEmitter<void>();

    openPageDetailsMsg: string = '';
    pageTypes: any;
    moduleName: string = '';
    hasAccessToDetailsOverlay: boolean = false;

    constructor (
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private globalHelperService: GlobalHelperService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.pageTypes = API_CONSTANTS.PAGES.TYPE;
        this.openPageDetailsMsg = this.translateService.getString('Open page details', {}, 'Aria label when clicking on open pagedetails');
        this.moduleName = this.globalHelperService.getCurrentModule();
        this.hasAccessToDetailsOverlay = this.activeFeatureService.isFeatureActive('page_details');
    }

    goToPageDetails (): void {
        const data = {
            page: this.page,
            target: this.target,
            subTarget: this.subTarget,
            ref: this.ref,
            infoType: this.infoType,
        };

        const params = {
            body: PageDetailsComponent,
            size: 'page-details',
            classes: 'page-details-app',
            data: data,
        };

        const options = {
            params,
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, options, () => {
            this.callBack.emit();
        });
    }
}
